import { parse } from '../../util/urlHelpers';
import { verify } from '../../ducks/emailVerification.duck';

// ================ Load data ================ //

export const loadData = (params, search) => {
  const urlParams = parse(search);
  const tokenHash = urlParams.token_hash ? `${urlParams.token_hash}` : null;
  const type = urlParams.type ? `${urlParams.type}` : null;
  const next = urlParams.next ? `${urlParams.next}` : null;
  return verify({ tokenHash, type, next });
};
